import React, { FC } from 'react';
import { ButtonProps } from 'components/Buttons/Button';
import { IntlShape } from 'react-intl';

import * as Styled from './ProjectsListCollapseButton.styles';
import { definedTranslation } from '../../../../i18n';

interface ProjectsListCollapseButtonProps extends ButtonProps {
  collapsed?: boolean;
  intl: IntlShape;
}

export const ProjectsListCollapseButton: FC<ProjectsListCollapseButtonProps> = (
  props,
) => {
  const { collapsed, intl, ...buttonProps } = props;
  const labels = {
    seeMore:
      intl?.formatMessage(definedTranslation.seeMoreButton) || 'See More',
    seeLess:
      intl?.formatMessage(definedTranslation.seeLessButton) || 'See Less',
  };

  return (
    <Styled.Button
      variant="text"
      endIcon={collapsed ? 'arrow-down' : 'arrow-up'}
      size="small"
      iconDense
      {...buttonProps}
    >
      {collapsed ? labels.seeMore : labels.seeLess}
    </Styled.Button>
  );
};
